import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#CEEDFF"
      d="m16 10-3.713-3.712a.99.99 0 0 0-.7-.288H5a1 1 0 0 0-1 1v18.075a.925.925 0 0 0 .925.925h22.188a.89.89 0 0 0 .887-.887V11a1 1 0 0 0-1-1z"
    />
    <path
      fill="#278CFF"
      fillRule="evenodd"
      d="M12.346 5.15c-.242-.1-.5-.15-.762-.15H5a2 2 0 0 0-2 2v18.075A1.925 1.925 0 0 0 4.925 27h22.188A1.89 1.89 0 0 0 29 25.113V11a2 2 0 0 0-2-2H16.414l-3.42-3.42a2 2 0 0 0-.648-.43M15.994 11H27v14H5V11zm-2.409-2-2-2H5v2z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFileGlobalFolder = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileGlobalFolder);
export default Memo;
